import React, { useState } from "react";
import { Layout } from "antd";
import LoginForm from "./component/login_form";
import { BRAND_NAME, WEB_DOMAIN } from "../../config/config";
import RegisterForm from "./component/register_form";
import "./style.css";
import DialogTermOfService from "./dialog/dialog_term_of_service";
import DialogPrivacyPolicy from "./dialog/dialog_privacy_policy";
import logo from "asset/img/logo/client.png";
import SEOHelmet from "component/seo/seo_helmet";

const { Content } = Layout;

const Login = () => {
  // -------------------------- STATE --------------------------
  const [tab, setTab] = useState("login");
  // -------------------------- FUNCTION --------------------------

  // -------------------------- RENDER --------------------------

  const Copyright = () => {
    return (
      <p className="min-h-[30px] text-center text-white">
        {"Copyright © "}
        <a color="inherit" href={WEB_DOMAIN} alt="Copyright">
          {BRAND_NAME}
        </a>{" "}
        {new Date().getFullYear()}
        {"."}
      </p>
    );
  };

  const renderLogin = () => {
    if (tab === "register") return null;
    return <LoginForm setTab={setTab} />;
  };

  const renderRegister = () => {
    if (tab === "login") return null;
    return <RegisterForm setTab={setTab} />;
  };

  const renderTermAndPolicy = () => {
    return (
      <div className="flex min-h-[60px] items-center justify-center gap-2 text-white">
        <a href="/term-of-service" className="hover:text-white hover:underline">
          Điều khoản dịch vụ
        </a>
        <span> | </span>
        <a href="/privacy-policy" className="hover:text-white hover:underline">
          Chính sách bảo mật
        </a>
      </div>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Layout className="full">
      <div className="bg-gradient-blue flex min-h-[100vh] flex-col items-center justify-center">
        <Content className="login">
          <div className="relative mx-auto my-auto flex min-h-[300px] max-w-[380px] flex-col gap-4 rounded-md bg-white p-[24px] shadow-lg">
            <a href="/">
              <img src={logo} className="mx-auto w-[100px]" alt="logo" />
            </a>
            <div className="text-center font-semibold">Đăng Nhập</div>
            {renderLogin()}
            {renderRegister()}
          </div>
        </Content>
        {renderTermAndPolicy()}
        <Copyright />
      </div>
      <DialogTermOfService />
      <DialogPrivacyPolicy />
      <SEOHelmet title="Đăng nhập - Dịch Vụ Chuyển Âm Support | Chuyển Âm Thanh Sang Word bằng AI" />
    </Layout>
  );
};

export default Login;
